import { configureStore } from "@reduxjs/toolkit";

import { userReducer } from './slices/user/user';
import candidatesReducer from './slices/candidates/candidate';
import projectsReducer from './slices/projects/project';

export default configureStore({
  reducer: {
    user: userReducer,
    candidates: candidatesReducer,
    projects: projectsReducer
  }
});